import { Fetcher } from 'swr'
import { Options, client } from '~/api/client'
import {
  Parameter$getCoordinatesSearchV2,
  Schemas,
  getCoordinatesSearchV2,
} from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'

export type Key = [
  operation: 'searchCoordinates',
  params: Parameter$getCoordinatesSearchV2,
]

export const createFetchSearchCoordinates = (opts?: Options) =>
  (async ([_, params]) => {
    const response = await getCoordinatesSearchV2(
      client,
      { parameter: params },
      opts
    )
    assertSuccess(response)

    return response.data
  }) satisfies Fetcher<Schemas.get_coordinates_search_v2_response, Key>

export const fetchSearchCoordinates = createFetchSearchCoordinates()
